
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/on-the-road-power-solution/support",
      function () {
        return require("private-next-pages/on-the-road-power-solution/support/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/on-the-road-power-solution/support"])
      });
    }
  